import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {ImportComponentComponent} from "../../shared/import-component/import-component.component";
import {ApiPathsService} from "../../api-paths.service";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-import-sconti',
  templateUrl: './import-sconti.component.html',
})
export class ImportScontiComponent implements AfterViewInit {
  @Output() Uploaded = new EventEmitter<any>();
  @ViewChild('ImportComponent')
  private ImportComponent:  ImportComponentComponent;
  constructor(
    private apiPaths: ApiPathsService,
    private modalService : NgbActiveModal,
  ) { }
  ngAfterViewInit(): void {
    this.ImportComponent.updateSelectedUrl(this.apiPaths.getBaseAPI() + '/prodotti/import/coupon');
  }
  uploaded(event){
    this.Uploaded.emit(event);
  }

  closeModal() {
    this.modalService.dismiss();
  }
}
